import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    aggregateId: string;
};

export const schemaUserResolver_GetSecret = z.string().nullable();

export type SchemaUserResolver_GetSecret = z.infer<typeof schemaUserResolver_GetSecret>;

export type UserResolver_GetSecret = Resolver<Arguments, SchemaUserResolver_GetSecret>;
